/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {bus} from '@/main';
import otherMenusList from '@/components/public/other-menus-list-section/';

export default {
  name: 'header-before-login',
  components: {
    'other-menus-list' : otherMenusList
  },
  props: [],
  data () {
    return {
      togglePopup: false,
      menusListPopup:false
    }
  },
  computed: {

  },
  mounted () {
    $(document).ready(function(){
    $(".Q_btn").click( function(){
      $(window).scrollTop(0);
      $(".firstbanner-in").toggleClass("active");
      $("body").toggleClass("login_box_hide");
    });
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".Q_btn, .welcome_popup .light_bg_section").length) {
      $("body").find(".firstbanner-in").removeClass("active");
      $("body").removeClass("login_box_hide");
      }
    });
  });
  bus.$on('menusListPopupBus', (data) => {
    this.menusListPopup = data;
  })
  },
  methods: {
    menusListPopupOpen(){
      this.menusListPopup = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg'); 
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
        }
    },
    togglePopupFunction(){
      this.togglePopup = !this.togglePopup;
      bus.$emit('togglePopipOverlay', this.togglePopup);
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}